<script setup lang="ts">
import type { CartPayControl } from "../cartControls";

defineProps<{ control: CartPayControl }>();
</script>

<template>
	<button
		type="button"
		class="buttonDefaultWrapper"
		:disabled="control.disabled"
		:id="control.disabled ? 'buttonDefaultDisabled' : ''"
		@click="control.action()"
	>
		{{ control.label }}
	</button>
</template>
